import Config from "../Config";

export async function checkEmail(value) {
	if (!value) return true // let required rule handle empty
	return fetch(Config.getUrl('emailCheck'), {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': window.vueStore.getters['session/jwt_authorization']
		},
		body: JSON.stringify({ emailAddress: value })
	})
	.then(res => {
		if (res.status === 200) {
			return true;
		}
		if (res.status === 409) {
			return false;
		}
			throw new Error('Unexpected response')
		})
	.catch(() => {
		return 'Could not verify email. Try again later.' // network/server error
	})
}
